import { v4 as uuidv4 } from 'uuid';
import jwtDefaultConfig from './jwtDefaultConfig'
import Router from '@/router'

export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => {
        this.setRequestId(config);

        // Get token from localStorage
        const accessToken = this.getToken()

        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }
        return config
      },
      error => Promise.reject(error),
    )

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      response => {
        this.removeRequestId(response.config.headers.requestId);
        return response
    },
      error => {
        this.removeRequestId(error.response.config.headers.requestId);

        const isSwitchUser = error.config?.url?.includes('switch-user');

        if (
            !isSwitchUser && (
              (error.response.status === 403 && !!localStorage.getItem('userData') && !!!localStorage.getItem('accessToken'))
              || (error.response.status === 401 && !!localStorage.getItem('userData') && !!!localStorage.getItem('accessToken'))
            )
        ) {
            Router.push({ name: 'logout' }).catch(()=>{})
        }
        return Promise.reject(error);
      },
    )
  }

  setRequestId(config) {
    const isIgnoredRequest = config.headers?.ignoredRequest;
    if(isIgnoredRequest) return;

    const requestList = JSON.parse(localStorage.getItem('requestList'))

    const UUID = uuidv4();
    config.headers.requestId = UUID;

    requestList.push(UUID)
    localStorage.setItem('requestList', JSON.stringify(requestList))
  }

  removeRequestId(requestId) {
    const requestList = JSON.parse(localStorage.getItem('requestList'));
    const requestIndex = requestList.indexOf(requestId);

    if(requestIndex === -1) return;

    requestList.splice(requestIndex, 1)
    localStorage.setItem('requestList', JSON.stringify(requestList));
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(args) {
    return this.axiosIns.post(this.jwtConfig.loginEndpoint(args.prefix), args)
  }

  logout(prefix) {
    return this.axiosIns.post(this.jwtConfig.logoutEndpoint(prefix))
  }

  register(...args) {
    return this.axiosIns.post(this.jwtConfig.registerEndpoint, ...args)
  }

  refreshToken() {
    return this.axiosIns.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken(),
    })
  }
}
